import app from "@/app";
import { ViewSwitchController, ViewSwitcher } from "./view-switch-controller";
import IncludeController from "./include-controller";
import ClipboardController from '@stimulus-components/clipboard'
import RevealController from '@stimulus-components/reveal'
import { FrameController } from "./frame-controller";
import { FrameContextController } from "./frame-context-controller";
import { ContextController } from "./context-controller";

// TODO: consider using turbo-frames as a more standard way to include and update html content asynchronously
// Note: turbo frames may not be robust enough to handle custom form control elements, or custom browser history state management
export const viewSwitcher = ViewSwitcher.initialize();
ViewSwitchController.viewSwitcher = viewSwitcher;
app.register("view-switch", ViewSwitchController);
app.register("include", IncludeController);
app.register("clipboard", ClipboardController);
app.register("reveal", RevealController);
app.register('frame', FrameController);
app.register('frame-context', FrameContextController);
app.register("context", ContextController);

// This way, the include can be triggered by a toggle event, when the state changes to open
app.registerActionOption("open", ({ event }) => {
    if (event.type == "toggle") {
        return (event.target as HTMLDetailsElement).open == true
    } else {
        return true
    }
})

